import { defineDictionary } from "gemi/client";

// Shared cookie-consent copy for both banners (the funnel CookieConsentBanner and the /v2-styled
// CookieConsentBannerV2). defineDictionary (gemi 0.54) resolves synchronously and needs no
// app/i18n/index entry or route prefetch, so the banner can never render a raw key. Keys are named
// after the copy, the locale objects are inline (gemi's Vite plugin needs a static literal), and
// `en-US` is first in every key as the source language and fallback.
export const cookieConsentDict = defineDictionary({
  message: {
    "en-US":
      "We use cookies to measure and improve our advertising. Accept to turn them on, or decline to keep them off.",
    "tr-TR":
      "Reklamlarımızı ölçmek ve geliştirmek için çerezler kullanıyoruz. Açmak için kabul edin ya da kapalı tutmak için reddedin.",
    "de-DE":
      "Wir verwenden Cookies, um unsere Werbung zu messen und zu verbessern. Akzeptieren Sie, um sie zu aktivieren, oder lehnen Sie ab, um sie deaktiviert zu lassen.",
    "it-IT":
      "Usiamo i cookie per misurare e migliorare la nostra pubblicità. Accetta per attivarli o rifiuta per lasciarli disattivati.",
    "fr-FR":
      "Nous utilisons des cookies pour mesurer et améliorer notre publicité. Acceptez pour les activer ou refusez pour les laisser désactivés.",
    "es-ES":
      "Usamos cookies para medir y mejorar nuestra publicidad. Acepta para activarlas o recházalas para dejarlas desactivadas.",
    "ru-RU":
      "Мы используем файлы cookie, чтобы оценивать и улучшать нашу рекламу. Примите, чтобы включить их, или отклоните, чтобы оставить их выключенными.",
  },
  accept: {
    "en-US": "Accept",
    "tr-TR": "Kabul et",
    "de-DE": "Akzeptieren",
    "it-IT": "Accetta",
    "fr-FR": "Accepter",
    "es-ES": "Aceptar",
    "ru-RU": "Принять",
  },
  reject: {
    "en-US": "Decline",
    "tr-TR": "Reddet",
    "de-DE": "Ablehnen",
    "it-IT": "Rifiuta",
    "fr-FR": "Refuser",
    "es-ES": "Rechazar",
    "ru-RU": "Отклонить",
  },
  privacy_link: {
    "en-US": "Privacy policy",
    "tr-TR": "Gizlilik politikası",
    "de-DE": "Datenschutz",
    "it-IT": "Informativa sulla privacy",
    "fr-FR": "Politique de confidentialité",
    "es-ES": "Política de privacidad",
    "ru-RU": "Политика конфиденциальности",
  },
});
